import * as actions from './action-types'
import * as mutations from './mutation-types'
import dayjs from 'dayjs'
import { defaultLocale, disableMessagesDelay } from '../app.config'
import * as constants from '../constants'
import { messageTypes } from '../model/messages'
import { languageToLocale } from '@/helpers/language'
import { setSocketPath } from '@/store/index'

let minDelay = 500
// noinspection JSUnusedLocalSymbols
const b4uSocketModule = {
  namespaced: false,
  state: {
    sessionId: null,
    connected: false,
    lastMessageDate: null,
    lastMessageLength: 0,
    lastMessageSuggestions: null,
    lastMessageSemanticSuggestions: null,
    lastMessageSuggestionsTitle: null,
    lastMessageSuggestionsOnly: false,
    messageList: [],
    socketMessages: [],
    operatorTakeOver: false,
    userTyping: false,
    operatorTyping: false,
    connectTimeout: null,
    isRestricted: false,
    speech: 'google',
    audioPlaying: false,
    operatorAvatarSrc: '',
    fileList: [],
    operatorTookOver: false,
    enabledLanguages: []
  },
  actions: {
    // eslint-disable-next-line no-unused-vars
    [actions.BOT_CONNECT]: () => {},
    [actions.BOT_DISCONNECT]: () => {
      global.isRestricted = false
    },
    [actions.ADD_BOT_MESSAGE]: (context, message) => {
      // let readingDuration = context.state.lastMessageLength * 20
      // minDelay = Math.max(readingDuration, minDelay)
      let delay = 0
      if (context.state.lastMessageDate) {
        delay = dayjs().diff(context.state.lastMessageDate, 'millisecond')
      }
      if (
        !(
          message.type === messageTypes.SYSTEM ||
          message.type === messageTypes.SYSTEM_NOTIFICATION
        )
      ) {
        context.commit(mutations.SET_EMOTION, '')
        delay = disableMessagesDelay
          ? 0
          : minDelay > delay
          ? minDelay - delay
          : 0
      }
      setTimeout(() => {
        context.commit(mutations.SOCKET_ON_MESSAGE, message)
      }, delay)
      context.state.lastMessageDate = new Date().getTime() + delay
      if (message && message.text) {
        context.state.lastMessageLength = message.text.length
      }
    },
    [actions.ADD_OPERATOR_MESSAGE]: (context, message) => {
      context.state.operatorTyping = false
      context.commit(mutations.SOCKET_ON_MESSAGE, message)
      context.state.lastMessageDate = new Date().getTime()
      context.state.lastMessageLength = message.text.length
    },
    [actions.UPDATE_SUGGESTIONS]: (context, suggestionsMessage) => {
      if (!suggestionsMessage && context.state.lastMessageSuggestions) {
        context.state.lastMessageSuggestions = null
        context.state.lastMessageSuggestionsTitle = null
        context.state.lastMessageSuggestionsOnly = false
      } else {
        context.state.lastMessageSuggestions = suggestionsMessage
          ? suggestionsMessage.suggestions
          : null
        context.state.lastMessageSuggestionsOnly = suggestionsMessage
          ? suggestionsMessage.suggestions_disallow_other_input
          : false
        context.state.lastMessageSuggestionsTitle =
          suggestionsMessage && suggestionsMessage.suggestions_title
            ? suggestionsMessage.suggestions_title[context.state.language]
            : null
      }
    },
    [actions.UPDATE_SEMANTIC_SUGGESTIONS]: (context, suggestionsMessage) => {
      if (!suggestionsMessage && context.state.lastMessageSemanticSuggestions) {
        context.state.lastMessageSemanticSuggestions = null
      } else {
        context.state.lastMessageSemanticSuggestions = suggestionsMessage
          ? suggestionsMessage.semanticSuggestions
          : null
      }
    },
    [actions.ADD_NOTIFICATION_MESSAGE]: (context, message) => {
      context.state.socketMessages.push(message)
      context.state.messageList.push(message)
      context.state.lastMessageDate = new Date().getTime()
    },
    [actions.EMIT_USER_LOGIN_MESSAGE]: () => {},
    [actions.REQUEST_SEMANTIC_SUGGESTIONS]: () => {},
    [actions.EMIT_USER_RESTART_MESSAGE]: context => {
      context.commit(mutations.CLEAR_MESSAGES)
    },
    [actions.EMIT_USER_MESSAGE_FEEDBACK]: context => {
      // context.commit(mutations.CLEAR_MESSAGES)
    },
    [actions.EMIT_SENT_FEEDBACK]: () => {
      // context.commit(mutations.CLEAR_MESSAGES)
    },
    [actions.TOGGLE_TYPING]: (context, state) => {
      context.state.userTyping = state
    },
    [actions.EMIT_NEW_USER_MESSAGE]: ({ commit }, message) => {
      commit(mutations.ADD_SOCKET_MESSAGE, 'emit to SEND_MESSAGE: ' + message)
      commit(mutations.SOCKET_EMIT_NEW_USER_MESSAGE, message)
    },
    [actions.SET_POST_MESSAGE_TARGET]: (context, postMessageTarget) => {
      context.commit(mutations.SET_POST_MESSAGE_TARGET, postMessageTarget)
    },
    [actions.SHOW_PROACTIVE_MESSAGE]: (context, message) => {
      context.commit(mutations.SHOW_PROACTIVE_MESSAGE, message)
    },
    [actions.ADD_TRANSCRIBED_USER_MESSAGE]: ({ commit }, message) => {
      commit(mutations.ADD_SOCKET_MESSAGE, 'emit to SEND_MESSAGE: ' + message)
      commit(mutations.SOCKET_EMIT_NEW_USER_MESSAGE, message)
    },
    [actions.ADD_UPLOADED_FILES]: (context, files) => {
      context.state.fileList.push(files)
    },
    [actions.SET_ENABLED_LANGUAGES]: (context, languages) => {
      context.state.enabledLanguages = languages
      if (!languages.includes(context.rootState.language.split('-')[0])) {
        context
          .dispatch(actions.SET_LANGUAGE, languageToLocale[languages[0]])
          .then(r => r)
      }
    }
  },
  getters: {
    isRestricted: state => {
      return state.isRestricted
    },
    sessionId: state => {
      return state.sessionId
    },
    quickReplies: state => {
      return (
        (state.messageList.length > 0
          ? state.messageList.filter(x => !x.isSystemMessage()).slice(-1)[0]
              .quick_replies
          : []) || []
      )
    },
    conclusionTicketFiles: state => {
      return state.fileList
    },
    latestMessage: state => {
      return state.messageList.slice(-1)[0]
    },
    showBotIsTypingIndicator: state => {
      return (
        !state.operatorTookOver &&
        (state.messageList.length < 1 ||
          (state.messageList.slice(-1)[0].author !== constants.AUTHOR_BOT &&
            state.messageList.slice(-1)[0].author !== constants.AUTHOR_SYSTEM &&
            state.messageList.slice(-1)[0].author !==
              constants.AUTHOR_OPERATOR))
      )
    },
    showOperatorIsTypingIndicator: state => {
      return state.operatorTyping
    },
    lastMessageSuggestionsTitle: state => {
      return state.lastMessageSuggestionsTitle
    }
  },
  mutations: {
    [mutations.SOCKET_EMIT_NEW_USER_MESSAGE]: async (state, message) => {
      state.messageList.push(message)
    },

    [mutations.ADD_MESSAGE]: (state, message) => {
      state.messageList.push(message)
    },
    [mutations.ADD_MESSAGES]: (state, messages) => {
      state.messageList = messages
    },

    [mutations.SOCKET_ON_SESSION_CONFIRM]: (state, sessionId) => {
      state.sessionId = sessionId
    },
    [mutations.SOCKET_ON_CONNECT]: state => {
      state.connected = true
      state.socketMessages.push('socket connected')
    },
    [mutations.SOCKET_ON_CONNECT_ERROR]: (state, error) => {
      state.connected = false
      state.socketMessages.push(`socket connection error: ${error}`)
    },
    [mutations.SOCKET_ON_RECONNECT_ATTEMPTS]: (state, count) => {
      state.connected = false
      state.socketMessages.push(`socket reconnection attempt: ${count}`)
    },
    [mutations.SOCKET_ON_MESSAGE]: (state, message) => {
      state.messageList.push(message)
      state.socketMessages.push(message)
    },
    [mutations.SOCKET_ON_ERROR]: (state, error) => {
      state.connected = false
      state.socketMessages.push(`socket error : ${error}`)
    },
    [mutations.SOCKET_ON_DISCONNECT]: state => {
      global.isRestricted = false
      state.connected = false
    },
    [mutations.SOCKET_ON_JOIN_CONFIRM]: (state, data) => {
      state.operatorTakeOver = true
      state.operatorAvatarSrc = data['operator_avatar_src']
    },
    [mutations.SOCKET_ON_LEAVE_CONFIRM]: state => {
      state.operatorTakeOver = false
      state.operatorAvatarSrc = ''
    },
    [mutations.SOCKET_ON_OPERATOR_TYPING]: (state, isTyping) => {
      state.operatorTyping = isTyping
      state.operatorTookOver = true
    },
    [mutations.ADD_SOCKET_MESSAGE]: (state, message) => {
      state.socketMessages.push(message)
      state.lastMessageDate = new Date().getTime()
    },
    [mutations.CLEAR_MESSAGES]: state => {
      state.messageList = []
    },
    [mutations.IS_RESTRICTED]: (state, data) => {
      state.isRestricted = data
    },
    [mutations.SET_SPEECH]: (state, data) => {
      state.speech = data
    },
    [mutations.CLEAR_FILES]: state => {
      state.fileList = []
    },
    [mutations.SET_POST_MESSAGE_TARGET]: (state, postMessageTarget) => {
      state.postMessageTarget = postMessageTarget
    },
    [mutations.SHOW_PROACTIVE_MESSAGE]: (state, message) => {
      // if (state.postMessageTarget) state.postMessageTarget.postMessage(message)
      const _message = {
        message: 'show',
        type: 'proactiveMessage',
        content: message
      }
      window.parent.postMessage(_message, '*')
    },
    [mutations.SOCKET_ON_LANGUAGE_CHANGE]: (state, sessionId) => {
      state.sessionId = sessionId
    }
  }
}

export default b4uSocketModule
